import React, { createContext, useContext, useEffect, useState } from "react";

// Theme is resolved BEFORE first paint by an inline script in index.html.
// This provider reads from that pre-paint state and never overrides it
// unless the user clicks the toggle. Persistence is via a 6-month cookie.
const COOKIE = "sme_theme";

function readCookie() {
  const m = document.cookie.match(new RegExp("(^| )" + COOKIE + "=([^;]+)"));
  return m ? decodeURIComponent(m[2]) : null;
}

function readInitial() {
  // Trust what the pre-paint script decided.
  if (document.documentElement.classList.contains("dark")) return "dark";
  return readCookie() === "dark" ? "dark" : "light";
}

const Ctx = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitial);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    // 6-month cookie so consent-banner-adjacent flows stay consistent.
    document.cookie = `${COOKIE}=${theme};path=/;max-age=15552000;SameSite=Lax`;
  }, [theme]);

  return (
    <Ctx.Provider value={{ theme, toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")) }}>
      {children}
    </Ctx.Provider>
  );
}

export const useTheme = () => useContext(Ctx);
